import Immutable from 'immutable';
import {
  BLOCKPAGE_PAGEUI_UPDATE,
  BLOCKPAGE_BLOCKUI_UPDATE,
  SET_PAGE_FAVOURITED,
  SET_PAGE_SUBSCRIBED_ACTION_TYPES,
  SET_PAGE_TRAVERSAL_LINKS,
  SET_PAGE_DISPLAY_OPTIONS,
  SET_COMMUNITY_OPTIONS,
  BLOCKPAGE_DATA_LOADED_SUCCESS,
  BLOCKPAGE_OPEN_SHARE_MODAL,
  BLOCKPAGE_CLOSE_SHARE_MODAL,
  SET_BLOCKPAGE_UI_MODE,
  SET_IS_COMMENT_REQUIRED_SUCCESS,
  BLOCKPAGE_UNMOUNT,
} from './actions';
import { SAVE_PAGE_SETTINGS_SUCCESS } from '../PageSettings/actions';
import { PageMode, BlockMode } from '../../web/containers/BlockPage/consts';

const INITIAL_STATE = Immutable.fromJS({
  pages: {
    // mountId: {
    //   { PageUIProp }
    //       .blocks => { BlockPageUIProp }
    // }
  },
  favourites: {
    // pagePath: {
    //   isFavourited: {bool}
    // }
  },
  subscriptions: {
    // pagePath: {
    //   actionTypes: []
    // }
  },
  traversalLinks: {
    // pagePath: {
    //    back: null,
    //    next: null,
    // }
  },
  displayOptions: {
    // pagePath: { largeText: bool }
  },
  communityOptions: {
    // pageId: { communityOptions }
  },
  userCommunityOptions: {
    // pageId: { userCommunityOptions }
  },
  currentShareModal: {},
  /**
   * <mountId>: {
   *   blockId: <string>,
   *   shareType: <string>,
   *   userData,
   *   onPost: func,
   * }
   */
});

const DEFAULT_PAGEUI = Immutable.fromJS({
  mode: PageMode.VIEW,
  showComments: false,
  blocks: {},

  isEditor: false,

  isDraggingBlock: false,
  draggedWidgetType: null, // widget identifier of block being added
  draggedBlockId: null, // blockId for block being dragged around

  pageGroupType: null, // if not null == group activity page
  courseGroupTypes: [],
  userCohortGroups: {},
});

const DEFAULT_BLOCKUI = Immutable.fromJS({
  mode: BlockMode.DISPLAY,
  showDropAnimation: false,
  activityGroup: null,
});

const updateBlockPageUI = (state, action) => {
  let newState = Immutable.fromJS(action.changes);

  // If there isn't an entry yet, set defaults
  if (!state.getIn(['pages', action.mountId], null)) {
    newState = DEFAULT_PAGEUI.merge(newState);
  }

  return state.mergeIn(['pages', action.mountId], newState);
};

const setUserCommunityOptions = (state, action) => {
  const { pageId, userCommunityOptions } = action;
  return state.setIn(
    ['userCommunityOptions', pageId],
    Immutable.fromJS(userCommunityOptions)
  );
};

const setCommunityOptions = (state, action) => {
  const { pageId, communityOptions } = action;
  return state.setIn(
    ['communityOptions', pageId],
    Immutable.fromJS(communityOptions)
  );
};

const setPageTraversalLinks = (state, action) => {
  const { pagePath, traversalLinks } = action;
  return state.setIn(
    ['traversalLinks', pagePath],
    Immutable.fromJS(traversalLinks)
  );
};

const setPageDisplayOptions = (state, action) => {
  const { pagePath, displayOptions } = action;
  return state.setIn(
    ['displayOptions', pagePath],
    Immutable.fromJS(displayOptions)
  );
};

const setPageIsFavourited = (state, action) => {
  const { pagePath, isFavourited } = action;
  return state.setIn(['favourites', pagePath, 'isFavourited'], isFavourited);
};

const setPageSubscribedActionTypes = (state, action) => {
  const { pagePath, subscribedActionTypes } = action;
  return state.setIn(
    ['subscriptions', pagePath, 'actionTypes'],
    Immutable.fromJS(subscribedActionTypes)
  );
};

const setCurrentShareModal = (state, action) => {
  const { blockId, shareType, userData, onPost, mountId } = action;
  return state.setIn(
    ['currentShareModal', mountId],
    Immutable.fromJS({ blockId, shareType, userData, onPost, mountId })
  );
};

const closeCurrentShareModal = (state, mountId) =>
  state.deleteIn(['currentShareModal', mountId]);

const updateBlockPageBlockUI = (mountId, blockId, changes, state) => {
  let newState = state;
  // If there isn't an entry yet, set defaults
  const key = ['pages', mountId, 'blocks', blockId];

  if (!newState.getIn(key, null)) {
    newState = newState.setIn(key, DEFAULT_BLOCKUI);
  }

  newState = newState.mergeIn(key, Immutable.fromJS(changes));
  return newState;
};

const updateBlockPageMode = (mountId, mode, state) => {
  let newState = state;
  const blockDisplayMode =
    mode === PageMode.EXHIBIT ? BlockMode.EXHIBIT : BlockMode.DISPLAY;
  const pageUI = newState.getIn(['pages', mountId], Immutable.Map());
  const blockIds = pageUI.get('blocks', Immutable.Map()).keySeq();
  // reset block modes after page mode change
  blockIds.forEach((blockId) => {
    newState = updateBlockPageBlockUI(
      mountId,
      blockId,
      { mode: blockDisplayMode },
      newState
    );
  });
  if (mode === PageMode.VIEW || mode === PageMode.FOCUS) {
    newState = updateBlockPageUI(newState, { mountId, changes: { mode } });
  } else if (pageUI.get('isEditor', false) && mode === PageMode.EDIT) {
    newState = updateBlockPageUI(newState, { mountId, changes: { mode } });
    if (blockIds.size === 1) {
      blockIds.forEach((blockId) => {
        newState = updateBlockPageBlockUI(
          mountId,
          blockId,
          { mode: BlockMode.SETUP },
          newState
        );
      });
    }
  }
  return newState;
};
/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function BlockPageUI(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_BLOCKPAGE_UI_MODE: {
      const { mountId, mode } = action;
      return updateBlockPageMode(mountId, mode, state);
    }
    case BLOCKPAGE_PAGEUI_UPDATE: {
      return updateBlockPageUI(state, action);
    }
    case BLOCKPAGE_BLOCKUI_UPDATE: {
      let newState = state;

      action.blockIds.forEach((blockId) => {
        newState = updateBlockPageBlockUI(
          action.mountId,
          blockId,
          action.changes,
          newState
        );
      });

      return newState;
    }
    case SET_PAGE_FAVOURITED: {
      return setPageIsFavourited(state, action);
    }
    case SET_PAGE_SUBSCRIBED_ACTION_TYPES: {
      return setPageSubscribedActionTypes(state, action);
    }
    case SET_PAGE_TRAVERSAL_LINKS: {
      return setPageTraversalLinks(state, action);
    }
    case SET_PAGE_DISPLAY_OPTIONS: {
      return setPageDisplayOptions(state, action);
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      let newState = state;
      const {
        mountId,
        pageId,
        pageRevisionId,
        viewedFrom,
        mode,
        pageData,
        blockData,
        blockQueryParams,
        userCommunityOptions,
        accessContext,
        userPermissions,
        groupOptions,
        userCohortGroups,
        pathContext,
      } = action;
      newState = updateBlockPageUI(newState, {
        mountId,
        pageId,
        revisionId: pageRevisionId,
        changes: {
          // stored where this blockpage ui is mounted from
          viewedFrom,

          canPostComments: userCommunityOptions.canPostComments,
          accessContext,

          // permissions
          isEditor: userPermissions.indexOf('write') !== -1,
          isAdmin: userPermissions.indexOf('admin') !== -1,

          // group switcher data
          pageGroupType: groupOptions.pageGroupType,
          courseGroupTypes: groupOptions.courseGroupTypes,
          userCohortGroups,

          // other stuff
          tags: pageData.tags,
          pathContext,
          scheduledAccess: blockData.scheduledAccess,

          // query parameters for any embedded iframe
          blockQueryParams,
        },
      });
      // Create initial block ui states before updating their modes
      blockData.blockList.forEach((block) => {
        newState = updateBlockPageBlockUI(mountId, block.id, {}, newState);
      });
      newState = updateBlockPageMode(mountId, mode, newState);
      newState = setPageSubscribedActionTypes(newState, action);
      newState = setPageIsFavourited(newState, action);
      newState = setPageDisplayOptions(newState, action);
      newState = setPageTraversalLinks(newState, action);
      newState = setCommunityOptions(newState, action);
      newState = setUserCommunityOptions(newState, action);
      return newState;
    }
    case BLOCKPAGE_UNMOUNT: {
      const { mountId } = action;
      return state.removeIn(['pages', mountId]);
    }
    case SET_COMMUNITY_OPTIONS: {
      return setCommunityOptions(state, action);
    }
    case SET_IS_COMMENT_REQUIRED_SUCCESS: {
      const { pageId, isCommentRequired } = action;
      return state.setIn(
        ['communityOptions', pageId, 'isCommentRequired'],
        isCommentRequired
      );
    }
    case SAVE_PAGE_SETTINGS_SUCCESS: {
      const { mountId, pageId, communityOptions, accessContext } = action;
      let newState = state;
      newState = setCommunityOptions(newState, { pageId, communityOptions });
      newState = updateBlockPageUI(newState, {
        mountId,
        changes: { accessContext },
      });
      return newState;
    }
    case BLOCKPAGE_OPEN_SHARE_MODAL: {
      return setCurrentShareModal(state, action);
    }
    case BLOCKPAGE_CLOSE_SHARE_MODAL: {
      const { mountId } = action;
      return closeCurrentShareModal(state, mountId);
    }
    default: {
      return state;
    }
  }
}
